import { createBrowserHistory } from "history";

export const sharedHistory = createBrowserHistory();

export const goBack = () => sharedHistory.goBack();
